import { render, staticRenderFns } from "./MonthlyAllowance.vue?vue&type=template&id=01d11399&scoped=true"
import script from "./MonthlyAllowance.vue?vue&type=script&lang=js"
export * from "./MonthlyAllowance.vue?vue&type=script&lang=js"
import style0 from "./MonthlyAllowance.vue?vue&type=style&index=0&id=01d11399&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d11399",
  null
  
)

export default component.exports